const actionTypes = require('../constants/actionTypes');
const apiURLBuilder = require('core/apiURLBuilder.js');
const { APIPost } = require('utilities/APIRequestHelper');
const {
  EURO_TEXT,
  ACCOUNT_INTERVENTION_OWNER,
  CARD_INTERVENTION_OWNER,
} = require('constants/index');
const moment = require('moment');
const { md5 } = require('utilities/hash');
const { typeAccountReturnString, typeCardReturnNumber } = require('utilities/expenses');
const { findContractFromHash } = require('utilities/movementsHelper');
const {
  DATE_FORMAT_API,
  GP_EXPENSES_FILTER_TYPE_ALL,
  GP_EXPENSES_FILTER_TYPE_ACCOUNTS,
  GP_EXPENSES_FILTER_TYPE_CARDS,
  GP_EXPENSES_FILTER_COMPARE_PREVIOUS,
} = require('constants/index');

const { ACCOUNTS, CARDS } = require('constants/aggregator/products');

const getGlobalPositionExpensesInProgress = () => ({
  type: actionTypes.GLOBAL_POSITION_EXPENSES_REQUEST,
});

const getGlobalPositionExpensesSuccess = (expensesLists, customDate) => ({
  type: actionTypes.GLOBAL_POSITION_EXPENSES_REQUEST_SUCCESS,
  payload: {
    expensesLists: Array.isArray(expensesLists) ? expensesLists : [],
    customDate: customDate,
  },
});

const getGlobalPositionExpensesFailure = error => ({
  type: actionTypes.GLOBAL_POSITION_EXPENSES_REQUEST_FAILURE,
  payload: {
    error,
  },
});

// **
const getGlobalPositionExpensesDetailInProgress = () => ({
  type: actionTypes.GLOBAL_POSITION_EXPENSES_DETAIL_REQUEST,
});

const getGlobalPositionExpensesDetailSuccess = expensesByCategory => ({
  type: actionTypes.GLOBAL_POSITION_EXPENSES_DETAIL_SUCCESS,
  payload: { expensesByCategory },
});

const getGlobalPositionExpensesDetailFailure = error => ({
  type: actionTypes.GLOBAL_POSITION_EXPENSES_DETAIL_FAILURE,
  payload: { error },
});

// **
const updateFiltersByCategoryAction = filtersByCategory => ({
  type: actionTypes.GLOBAL_POSITION_EXPENSES_UPDATE_FILTERS_BY_CATEGORY,
  payload: {
    filtersByCategory,
  },
});

const resetCategories = () => ({ type: actionTypes.GLOBAL_POSITION_CATEGORIES_EXPENSES_RESET });

const completeExpensesWithContractData = function (response, immAccounts, immCards) {
  let values = [];

  response.forEach(item => {
    const contract = findContractFromHash({
      hash: item.contrato,
      typeAccount: item.tipoCuenta,
      accounts: immAccounts.get('byId', immAccounts),
      cards: immCards.get('byId', immCards),
    });

    if (!!contract) {
      values.push(
        Object.assign({}, item, {
          currency: contract.balance ? contract.balance.currency : 'EUR',
          contract: contract.iban || contract.number,
          contractId: contract.accountId || contract.cardId || contract.id,
          description: contract.description || contract.alias,
        })
      );
    }
  });

  return values;
};

const filterOtherBanksVisibleProduct = (products, typeAccount, banks = []) => {
  return products.filter(product => {
    if (typeAccount === 'custom') {
      return (
        product.get('visible') && banks && banks.includes && banks.includes(product.get('bank'))
      );
    } else {
      return banks && banks.includes && banks.includes(product.get('bank'));
    }
  });
};

// Filter accounts in EUROS, visible in global position, and in which the user is 'titular'
const filterOwnVisibleEuroAccounts = (immAccounts, typeAccount) => {
  return immAccounts.get('byOrder').filter(accountId => {
    const immAccount = immAccounts.getIn(['byId', accountId]);

    if (typeAccount === 'custom') {
      return (
        immAccount.getIn(['balance', 'currency']) === EURO_TEXT &&
        immAccount.getIn(['filters', 'valid']) &&
        immAccount.get('interventionType') === ACCOUNT_INTERVENTION_OWNER
      );
    } else {
      return (
        immAccount.getIn(['balance', 'currency']) === EURO_TEXT &&
        immAccount.get('interventionType') === ACCOUNT_INTERVENTION_OWNER
      );
    }
  });
};

// Filter cards visible in global position, and in which the user is 'titular'
const filterOwnVisibleCards = (immCards, typeAccount) => {
  const immCreditCards = immCards.get('credit'); //commented out until we have catalog data working again

  return immCreditCards.get('byOrder').filter(cardId => {
    const immCard = immCards.getIn(['byId', cardId]);

    if (typeAccount === 'custom') {
      return (
        immCard.getIn(['filters', 'valid']) &&
        immCard.get('type') === 'credit' &&
        immCard.get('interventionType') === CARD_INTERVENTION_OWNER
      );
    } else {
      return (
        immCard.get('type') === 'credit' &&
        immCard.get('interventionType') === CARD_INTERVENTION_OWNER
      );
    }
  });
};

// Function to get information about expenses
const requestExpenses =
  (customDate, typeAccountFilter, typeCard, banks) => (dispatch, getState) => {
    let filteredAccountsProducts = [];
    let filteredCardsPans = [];
    let filterGroupContract = '2';
    let today;
    let firstDayOfPreviousMonth;
    const immAccounts = getState().accounts;
    const immCards = getState().cards;
    const immCreditCards = getState().cards;
    const immExpenses = getState().globalPosition.get('expenses');
    const compareFilter = getState().globalPosition.get('expenses').getIn(['filters', 'compare']);
    const filterDateIsActive = getState().globalPosition.getIn([
      'expenses',
      'filtersByCategory',
      'date',
      'isActive',
    ]);
    const filterDateFromValue = getState().globalPosition.getIn([
      'expenses',
      'filtersByCategory',
      'date',
      'from',
    ]);
    const filterDateToValue = getState().globalPosition.getIn([
      'expenses',
      'filtersByCategory',
      'date',
      'to',
    ]);
    const customToday = filterDateIsActive
      ? filterDateToValue.format(DATE_FORMAT_API)
      : moment().startOf('day').format(DATE_FORMAT_API);
    const customLastYear = filterDateIsActive
      ? filterDateFromValue.format(DATE_FORMAT_API)
      : moment().startOf('month').format(DATE_FORMAT_API);
    const filterType = immExpenses.getIn(['filters', 'type']);
    const typeAccount = typeAccountFilter ? typeAccountFilter : 'all';
    const selectedDate =
      getState().globalPosition.getIn(['expenses', 'filtersByCategory', 'date', 'selected']) ===
      'None';
    const aggregatorData = getState().aggregatorData.get('data');

    if (typeCard !== undefined) {
      filterGroupContract = typeCardReturnNumber(typeCard);
    }

    if (compareFilter !== GP_EXPENSES_FILTER_COMPARE_PREVIOUS || customDate) {
      today = customDate ? customToday : moment().startOf('day').format(DATE_FORMAT_API);
      firstDayOfPreviousMonth = customDate
        ? customLastYear
        : moment().startOf('month').format(DATE_FORMAT_API);
    } else {
      today = moment().startOf('day').format(DATE_FORMAT_API);
      firstDayOfPreviousMonth = moment()
        .subtract(1, 'month')
        .startOf('month')
        .format(DATE_FORMAT_API);
    }

    if (!!banks && Array.isArray(banks)) {
      if (
        filterType === GP_EXPENSES_FILTER_TYPE_ALL ||
        filterType === GP_EXPENSES_FILTER_TYPE_ACCOUNTS
      ) {
        if (filterGroupContract === '0' || filterGroupContract === '2') {
          const accounts = aggregatorData
            .get('products')
            .toIndexedSeq()
            .filter(p => p.get('product') == ACCOUNTS);
          filteredAccountsProducts = filterOtherBanksVisibleProduct(accounts, typeAccount, banks)
            .map(account => {
              return account.get('iban');
            })
            .toJS();
        }
      }

      if (
        filterType === GP_EXPENSES_FILTER_TYPE_ALL ||
        filterType === GP_EXPENSES_FILTER_TYPE_CARDS
      ) {
        if (filterGroupContract === '1' || filterGroupContract === '2') {
          const cards = aggregatorData
            .get('products')
            .toIndexedSeq()
            .filter(p => p.get('product') == CARDS);
          filteredCardsPans = filterOtherBanksVisibleProduct(cards, typeAccount, banks)
            .map(card => {
              return card.get('number');
            })
            .toJS();
        }
      }
    } else {
      if (
        filterType === GP_EXPENSES_FILTER_TYPE_ALL ||
        filterType === GP_EXPENSES_FILTER_TYPE_ACCOUNTS
      ) {
        if (filterGroupContract === '0' || filterGroupContract === '2') {
          filteredAccountsProducts = filterOwnVisibleEuroAccounts(immAccounts, typeAccount)
            .map(accountId => {
              const immAccount = immAccounts.getIn(['byId', accountId]);
              return immAccount.get('iban');
            })
            .toJS();
        }
      }

      if (
        filterType === GP_EXPENSES_FILTER_TYPE_ALL ||
        filterType === GP_EXPENSES_FILTER_TYPE_CARDS
      ) {
        if (filterGroupContract === '1' || filterGroupContract === '2') {
          filteredCardsPans = filterOwnVisibleCards(immCards, typeAccount)
            .map(cardId => {
              const immCard = immCreditCards.getIn(['byId', cardId]);

              return immCard.get('number');
            })
            .toJS();
        }
      }
    }

    const requestData = {
      query: {
        cards: filteredCardsPans,
        ibans: filteredAccountsProducts,
        from: selectedDate
          ? moment().subtract(2, 'year').startOf('month').format(DATE_FORMAT_API)
          : firstDayOfPreviousMonth,
        to: selectedDate ? moment().startOf('day').format(DATE_FORMAT_API) : today,
        banks:
          !!banks && Array.isArray(banks)
            ? banks.map(b => aggregatorData.getIn(['banks', b, 'code']))
            : null,
      },
    };

    dispatch(getGlobalPositionExpensesInProgress());
    APIPost(dispatch, apiURLBuilder.getURL('globalExpensesTotals'), requestData)
      .then(response => dispatch(getGlobalPositionExpensesSuccess(response, customDate)))
      .catch(error => dispatch(getGlobalPositionExpensesFailure(error)));
  };

// Function to get information about expenses filtered by categories
const requestExpensesByCategory =
  (category, typeAccountPG, typeCard, banks) => (dispatch, getState) => {
    const immCards = getState().cards;
    const immAccounts = getState().accounts;
    const immExpenses = getState().globalPosition.get('expenses');
    let filterGroupContract = getState().globalPosition.getIn([
      'expenses',
      'filtersByCategory',
      'groupContract',
      'value',
    ]);
    const filterDateIsActive = getState().globalPosition.getIn([
      'expenses',
      'filtersByCategory',
      'date',
      'isActive',
    ]);
    const filterDateFromValue = getState().globalPosition.getIn([
      'expenses',
      'filtersByCategory',
      'date',
      'from',
    ]);
    const filterDateToValue = getState().globalPosition.getIn([
      'expenses',
      'filtersByCategory',
      'date',
      'to',
    ]);
    const filterDateSelected = getState().globalPosition.getIn([
      'expenses',
      'filtersByCategory',
      'date',
      'selected',
    ]);
    let typeAccount = immExpenses.getIn(['filtersByCategory', 'typeAccount', 'value']);
    const aggregatorData = getState().aggregatorData.get('data');

    const filterType = getState().globalPosition.getIn(['expenses', 'filters', 'type']);

    if (typeCard !== undefined) {
      filterGroupContract = typeCardReturnNumber(typeCard);
    }

    if (typeAccountPG !== undefined) {
      typeAccount = typeAccountReturnString(typeAccountPG);
    }

    let filteredCardsPans = [];
    let filteredCardsPansNumbers = [];
    let filteredAccountsProducts = [];
    let filteredAccountsProductsNumbers = [];

    if (!!banks && Array.isArray(banks)) {
      if (
        filterType === GP_EXPENSES_FILTER_TYPE_ALL ||
        filterType === GP_EXPENSES_FILTER_TYPE_ACCOUNTS
      ) {
        if (filterGroupContract === '0' || filterGroupContract === '2') {
          const accounts = aggregatorData
            .get('products')
            .toIndexedSeq()
            .filter(p => p.get('product') == ACCOUNTS);
          filterOtherBanksVisibleProduct(accounts, typeAccount, banks).forEach(account => {
            filteredAccountsProducts.push({
              name: account.get('alias'),
              number: account.get('iban'),
            });
            filteredAccountsProductsNumbers.push(account.get('iban'));
          });
        }
      }

      if (
        filterType === GP_EXPENSES_FILTER_TYPE_ALL ||
        filterType === GP_EXPENSES_FILTER_TYPE_CARDS
      ) {
        if (filterGroupContract === '1' || filterGroupContract === '2') {
          const cards = aggregatorData
            .get('products')
            .toIndexedSeq()
            .filter(p => p.get('product') == CARDS);
          filterOtherBanksVisibleProduct(cards, typeAccount, banks).forEach(card => {
            filteredCardsPans.push({
              name: card.getIn('alias'),
              number: card.getIn('number'),
            });
            filteredCardsPansNumbers.push(card.get('number'));
          });
        }
      }
    } else {
      if (
        filterType === GP_EXPENSES_FILTER_TYPE_ALL ||
        filterType === GP_EXPENSES_FILTER_TYPE_ACCOUNTS
      ) {
        if (filterGroupContract === '0' || filterGroupContract === '2') {
          filterOwnVisibleEuroAccounts(immAccounts, typeAccount).forEach(id => {
            filteredAccountsProducts.push({
              name: immAccounts.getIn(['byId', id, 'description']),
              number: immAccounts.getIn(['byId', id, 'iban']),
            });
            filteredAccountsProductsNumbers.push(immAccounts.getIn(['byId', id, 'iban']));
          });
        }
      }

      if (
        filterType === GP_EXPENSES_FILTER_TYPE_ALL ||
        filterType === GP_EXPENSES_FILTER_TYPE_CARDS
      ) {
        if (filterGroupContract === '1' || filterGroupContract === '2') {
          filterOwnVisibleCards(immCards, typeAccount).forEach(id => {
            filteredCardsPans.push({
              name: immCards.getIn(['byId', id, 'alias', 'current']),
              number: immCards.getIn(['byId', id, 'number']),
            });
            filteredCardsPansNumbers.push(immCards.getIn(['byId', id, 'number']));
          });
        }
      }
    }

    const today = moment().startOf('day');
    const currentDayOfPreviousMonth = moment().startOf('month');

    const requestData = {
      query: {
        category: category,
        contracts: [...filteredCardsPansNumbers, ...filteredAccountsProductsNumbers],
        from: filterDateIsActive
          ? filterDateFromValue.format(DATE_FORMAT_API)
          : currentDayOfPreviousMonth.format(DATE_FORMAT_API),
        to: filterDateIsActive
          ? filterDateToValue.format(DATE_FORMAT_API)
          : today.format(DATE_FORMAT_API),
        banks:
          !!banks && Array.isArray(banks)
            ? banks.map(b => aggregatorData.getIn(['banks', b, 'code']))
            : null,
      },
    };

    dispatch(getGlobalPositionExpensesDetailInProgress());

    dispatch(
      updateFiltersByCategoryAction({
        contracts: {
          isActive: false,
          accountsContracts: filteredAccountsProducts.map(item => {
            return {
              name: item.name,
              number: item.number,
              selected: true,
            };
          }),
          cardsContracts: filteredCardsPans.map(item => {
            return {
              name: item.name,
              number: item.number,
              selected: true,
            };
          }),
        },
        date: {
          from: filterDateIsActive ? filterDateFromValue : currentDayOfPreviousMonth,
          isActive: true,
          selected: filterDateIsActive ? filterDateSelected : 'Custom',
          to: filterDateIsActive ? filterDateToValue : today,
        },
        subcategory: {
          isActive: false,
          subcategory: 'all',
        },
        groupContract: {
          value: filterGroupContract,
        },
        typeAccount: {
          value: typeAccount,
        },
      })
    );

    APIPost(dispatch, apiURLBuilder.getURL('globalExpensesByCategory'), requestData)
      .then(response => {
        const accountsTmp = !banks
          ? immAccounts
          : aggregatorData
              .get('products')
              .filter(
                p =>
                  p.get('product') == ACCOUNTS &&
                  banks &&
                  banks.includes &&
                  banks.includes(p.get('bank'))
              )
              .mapKeys((k, v) => md5(v.get('iban', k)));
        const cardsTmp = !banks
          ? immCards
          : aggregatorData
              .get('products')
              .filter(
                p =>
                  p.get('product') == CARDS &&
                  banks &&
                  banks.includes &&
                  banks.includes(p.get('bank'))
              )
              .mapKeys((k, v) => md5(v.get('number', k)));
        const newResponse = completeExpensesWithContractData(response, accountsTmp, cardsTmp);
        dispatch(getGlobalPositionExpensesDetailSuccess(newResponse));
      })
      .catch(error => dispatch(getGlobalPositionExpensesDetailFailure(error)));
  };

// Function to get information about card expenses filtered by categories
const requestCardExpensesByCategory = (category, cardId) => (dispatch, getState) => {
  const today = moment().startOf('day');
  const immDate = getState().globalPosition.getIn(['expenses', 'filtersByCategory', 'date']);
  const filterDateFromValue = immDate.get('from');
  const filterDateToValue = immDate.get('to');
  const beginningOfTime = moment().subtract(11, 'months').startOf('month');

  const immCards = getState().cards;
  const immCard = immCards.getIn(['byId', cardId]);
  const number = immCard.get('number');
  const immAccounts = getState().accounts;
  const dateFrom = filterDateFromValue || beginningOfTime;
  const dateTo = filterDateToValue || today;

  const requestData = {
    query: {
      category: category,
      contracts: [number],
      from: dateFrom.format(DATE_FORMAT_API),
      to: dateTo.format(DATE_FORMAT_API),
    },
  };

  dispatch(getGlobalPositionExpensesDetailInProgress());

  APIPost({ dispatch, endpoint: 'globalExpensesByCategory', params: requestData })
    /* Response is empty at success, so we pass the tentative limit as the new approved amount.
     * We are not handling operationId here as in the card increase limit.
     */
    .then(response => {
      const newResponse = completeExpensesWithContractData(response, immAccounts, immCards);
      dispatch(getGlobalPositionExpensesDetailSuccess(newResponse));
    })
    .catch(response => {
      if (!!response.error) {
        dispatch(getGlobalPositionExpensesDetailFailure(response));
      } else {
        throw response;
      }
    });
};

module.exports = {
  requestExpenses,
  requestExpensesByCategory,
  requestCardExpensesByCategory,
  resetCategories,
  updateFiltersByCategoryAction,
};
